import {
  MARKET_MODES,
  MARKET_MODE_STATUS,
  Market
} from "../market";

const OZON_FAQ = [
  {
    title: "Что такое пользовательский сценарий взаимодействия с карточкой товара?",
    isH3: true,
    text: (
      <div>
        Пользовательский сценарий — это заранее заданная последовательность действий, которую реальный пользователь может выполнить при взаимодействии с карточкой товара на маркетплейсе. 
        <br />
        Такие действия могут включать:
        <br />
        <br />
        <ul>
          <li>Поиск товара по ключевым словам</li>
          <li>Изучение карточки: описание, характеристики, фото</li>
          <li>Добавление товара в избранное или корзину (по условиям задания)</li>
          <li>Анализ цен, отзывов, сопутствующих товаров</li>
        </ul>
        <br />
        Сценарии позволяют получить обратную связь о восприятии карточки товара, а также собрать данные о том, какие элементы привлекают внимание пользователей.
      </div>
    ),
  },
  {
    title: "Зачем нужны пользовательские сценарии?",
    isH3: true,
    text: (
      <div>
        <ul>
          Такой формат взаимодействия помогает:
          <br />
          <br />
          <li>Проверить, насколько легко найти товар по определенным запросам</li>
          <li>Понять, какие элементы карточки вызывают интерес или вопросы</li>
          <li>Получить данные для улучшения структуры и содержания страницы</li>
          <li>Смоделировать типичное поведение потенциального покупателя</li>
        </ul>
        <br />
        Исполнители получают индивидуальные задания и делятся отчетами по завершении. Это позволяет оценить путь пользователя и при необходимости оптимизировать карточку.
      </div>
    ),
  },
  {
    title: "Кто выполняет задания?",
    isH3: true,
    text: (
      <p>
        Задания исполняют реальные пользователи, заинтересованные в тестировании. 
        <br />
        Каждый из них работает вручную по индивидуальной инструкции. 
        <br />
        Все задания проходят модерацию и могут быть отклонены, если не соответствуют условиям.
        <br />
        <br />
        <b>Важно</b>
        <br />
        • Все сценарии — это исследовательский инструмент, а не гарантия продвижения или роста продаж
        <br />
        • Boostclick не оказывает услуги по продвижению на Ozon* и не влияет на алгоритмы ранжирования
        <br />
        • Весь процесс направлен на анализ и сбор пользовательского опыта
      </p>
    ),
  },
/*   {
    title: "Как оплатить улучшение поведенческого фактора?",
    isH3: true,
    text: (
      <p>
        Пополнить личный кабинет Boostclick можно любым удобным способом через
        сервис Робокасса.
        <br />
        Минимальная оплата для физических лиц {`\u00A0—\u00A090\u00A0`}рублей.
        <br />
        Минимальная сумма пополнения для юридических лиц
        {`\u00A0—\u00A010000\u00A0`}рублей.
      </p>
    ),
  }, */
];

/* const OZON_ARTICLE = {
  title: 'Продвижение карточек на OZON* через поведенческие факторы в 2025 году',
  content: <div>
    Продвижение товаров на маркетплейсах уже давно вышло за рамки классического SEO и рекламных ставок. В 2025 году главным драйвером роста позиций карточек на OZON становятся поведенческие факторы — метрики, которые показывают платформе, насколько ваш товар действительно интересен пользователям. Это естественный фильтр для системы и инструмент роста для продавцов, которые понимают логику алгоритмов.
    <br />
    <br />
    <h3>Что такое поведенческие факторы на OZON*</h3>
    <br />
    <ul>
      Поведенческие факторы (или ПФ) — это совокупность действий пользователей, фиксируемых системой:
      <li>клики по карточке товара;</li>
      <li>добавления в избранное и корзину;</li>
      <li>время, проведённое на странице;</li>
      <li>просмотры изображений и отзывов;</li>
      <li>частота возвратов и переходов по ссылкам;</li>
      <li>соотношение показов к кликам (CTR) и конверсия в покупку.</li>
    </ul>
    <br />
    Алгоритмы OZON в 2025 году оценивают эти метрики комплексно. Даже при одинаковой цене и отзывах карточка с высоким «пользовательским интересом» получает приоритет в выдаче. Именно поэтому работа с поведенческими факторами становится не просто инструментом оптимизации, а частью стратегии видимости товара.
    <br />
    <br />
    <h3>Продвижение карточек на OZON* через поведенческие факторы в 2025 году</h3>
    <br />
    Продвижение товаров на маркетплейсах в 2025 году всё чаще связывают с поведенческими факторами — метриками, которые могут влиять на ранжирование и видимость карточек. Хотя точные алгоритмы OZON не раскрываются, продавцы отмечают, что устойчивый интерес пользователей нередко совпадает с ростом позиций и продаж.
    <br />
    <br />
    <h3>Что понимают под поведенческими факторами</h3>
    <br />
    <ul>
      Под поведенческими факторами (ПФ) обычно подразумевают действия пользователей, фиксируемые системой:
      <li>клики по карточке и просмотры;</li>
      <li>добавления в избранное и корзину;</li>
      <li>время взаимодействия с контентом;</li>
      <li>открытие отзывов и изображений;</li>
      <li>частота повторных визитов;</li>
      <li>соотношение показов и переходов.</li>
    </ul>
    <br />
    Все эти параметры могут косвенно отражать интерес к товару и влиять на внутреннюю статистику карточки. В результате система способна чаще показывать такие объявления — не как гарантию, а как следствие пользовательского поведения.
    <br />
    <br />
    <h3>Почему стандартные методы уже не дают стабильного результата</h3>
    <br />
    Реклама, скидки и акции по-прежнему важны, но в 2025 году они всё чаще работают в комплексе с поведенческой аналитикой.
    <br />
    Когда карточка получает органичные клики, удерживает внимание и вызывает положительные действия (например, добавление в корзину), платформа может интерпретировать это как признак интереса к товару.
    <br />
    При этом механические попытки привлечь трафик без вовлечения аудитории уже не показывают устойчивого эффекта.
    <br />
    Поэтому продавцы переходят от прямого продвижения к тестированию пользовательских сценариев — наблюдают, как люди реагируют на фото, цену, заголовок или описание.
    <br />
    <br />
    <h3>Баланс между продвижением и тестированием ПФ</h3>
    <br />
    Термин «накрутка ПФ» в данном контексте используется условно. В большинстве случаев речь идёт не о нарушении правил, а об имитации сценариев поведения для аналитических целей.
    <br />
    Если действия выполняются людьми и направлены на тестирование реакции аудитории — например, на проверку удобства карточки или привлекательности цены, — это не считается вмешательством в работу алгоритмов.
    <br />
    <br />
    Сервис Boostclick предоставляет инструменты для безопасного анализа таких сценариев. С его помощью можно оценить, какие карточки вызывают интерес, где пользователи теряют внимание и какие элементы стимулируют целевое действие.
    <br />
    <br />
    <h3>Возможное влияние ПФ на выдачу</h3>
    <br />
    OZON официально не раскрывает принципы ранжирования, однако из открытых источников и опыта продавцов следует, что система может учитывать совокупность пользовательских метрик.
    <br />
    <br />
    <ul>
      Например:
      <li>карточки с высоким CTR чаще показываются в похожих товарах;</li>
      <li>большое количество возвратов к просмотру может указывать на интерес аудитории;</li>
      <li>динамика добавлений в корзину вероятно влияет на внутренние рекомендации.</li>
    </ul>
    <br />
    Таким образом, работа с ПФ рассматривается не как способ «накрутки», а как инструмент понимания того, что именно вызывает реакцию покупателей.
    <br />
    <br />
    <h3>Осознанное продвижение и юридическая чистота</h3>
    <br />
    Важно помнить, что любые действия, направленные на искусственное повышение метрик без фактического интереса покупателей, могут противоречить политике площадки.
    <br />
    Поэтому ключевой задачей становится не манипуляция показателями, а построение реалистичных моделей поведения: как пользователи изучают карточку, какие изображения удерживают внимание, какой текст мотивирует вернуться.
    <br />
    Boostclick позволяет работать именно с такими сценариями — моделировать интерес, анализировать результаты и улучшать карточки без вмешательства в работу алгоритмов.
    <br />
    <br />
    <h3>Итог</h3>
    <br />
    В 2025 году продвижение карточек на OZON через поведенческие факторы — это скорее исследовательский инструмент, чем метод прямого воздействия на ранжирование.
    <br />
    Такая стратегия помогает продавцам глубже понимать аудиторию, повышать привлекательность карточек и адаптировать контент под реальные ожидания покупателей.
  </div>
}; */

const STEP_TWO_TITLE_FAQ = (
  <p>
    Почему при добавлении одного действия в калькуляторе появляются
    дополнительные действия?
    <br />
    <br />
    Сервис формирует уникальные сценарии для каждого исполнителя, и каждый
    сценарий начинается для нового исполнителя с поиска товара по сделанному
    скриншоту вашей ссылки.
  </p>
);

const REVIEW_PRICE = 250;

const ACTIONS = [
  {
    type: "MAIN.FAVORITE",
    icon: "heart",
    iconHome: "home-heart",
    title: "Добавить товар в избранное",
    initialShare: 0.5,
    activityType: 'Избранное',
  },
  {
    type: "MAIN.STAR",
    icon: "star",
    iconHome: "home-star",
    title: "Добавить бренд в избранное",
    initialShare: 0.2,
    activityType: 'Избранное',
  },
  {
    type: "MAIN.BUSKET",
    icon: "busket",
    iconHome: "home-busket",
    title: "Добавить товар в корзину",
    initialShare: 0.2,
    activityType: 'Корзина',
  },
  {
    type: "MAIN.LIKE",
    icon: "like",
    iconHome: "home-like",
    title: "Поставить положительную реакцию на отзыв",
    initialShare: 0.1,
    activityType: 'Лайк',
  },

  {
    type: "ALWAYS.OPEN",
    icon: "open",
    iconHome: "home-open",
    title: "Открыть сайт или приложение OZON",
    initialShare: 1,
  },
  {
    type: "ALWAYS.SEARCH",
    icon: "search",
    iconHome: "home-search",
    title: "Найти товар через поиск OZON",
    initialShare: 1,
  },
  {
    type: 'ALWAYS.COMPETITORS',
    icon: "time",
    iconHome: "home-time",
    title: 'Быстро просмотреть конкурентов',
    initialShare: 1,
  },
  {
    type: "ALWAYS.CLICK",
    icon: "click",
    iconHome: "home-click",
    title: "Зайти на карточку товара",
    initialShare: 1.0,
  },

  {
    type: "EXTRA.MEDIA",
    icon: "eye",
    iconHome: "home-eye",
    title: "Посмотреть все фото и видео на карточке",
    initialShare: 0.6,
  },
  {
    type: "EXTRA.DESCRIPTION",
    icon: "glasses",
    iconHome: "home-glasses",
    title: "Прочитать полное описание",
    initialShare: 0.2,
  },
  {
    type: "EXTRA.GOODS",
    icon: "click",
    iconHome: "home-click",
    title: "Посмотреть другие товары продавца",
    initialShare: 0.1,
  },
  {
    type: "EXTRA.FEEDBACKS",
    icon: "glasses",
    iconHome: "home-glasses",
    title: "Прочитать отзывы на товар",
    initialShare: 0.1,
  },
  {
    type: "MAIN.DISLIKE",
    icon: "dislike",
    iconHome: "home-dislike",
    title: "Поставить отрицательную реакцию на отзыв",
    initialShare: 0,
    activityType: 'Дизлайк',
    hidden: true,
  },
  {
    type: "MAIN.APPEAL",
    icon: "dislike",
    iconHome: "home-dislike",
    title: "Пожаловаться на последний отзыв",
    initialShare: 0,
    activityType: 'Жалоба',
    hidden: true,
  },
];

const MAIN_PAGE_TITLES = [
  {
    iconHome: "home-action",
    title: "Поведенческая активность",
    titleComment: "Изучение товаров",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
    statusForHomePage: MARKET_MODE_STATUS.HIT,
  },
  {
    iconHome: "home-heart",
    title: "В избранное",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-star",
    title: "В избранное (бренд)",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-busket",
    title: "В корзину",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-like",
    title: "Оценить отзыв",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-open",
    title: "Переход по ссылке",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-search",
    title: "Найти товар",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-glasses",
    title: "Сравнение товаров",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  },
  {
    iconHome: "home-click",
    title: "Карточка товара",
    path: "/povedencheskie-faktory-na-ozon",
    target: '_self',
  }
];

const STEP_PHRASE_2 = "Укажите информацию для поиска товара";

const OZON_KEYWORDS = [
  'Ozon', 'ozon', 'Озон', 'озон'
];

class OzonClass extends Market {
  id = "ozon";
  host = "ozon.ru";
  url = "https://ozon.ru/";

  title = "OZON";

  isMarketplace = true;

  icon = "ozon";
  titlePlaces = "OZON";
  statusForHomePage = MARKET_MODE_STATUS.POPULAR;
  mainPageTitles = MAIN_PAGE_TITLES;

  categories = [
    { type: "Электроника" },
    { type: "Одежда" },
    { type: "Обувь" },    
    { type: "Дом и сад" },
    { type: "Детские товары" },
    { type: "Красота и здоровье" },
    { type: "Бытовая техника" },
    { type: "Спорт и отдых" },
    { type: "Строительство и ремонт" },
    { type: "Продукты питания" },
    { type: "Аптека" },
    { type: "Товары для животных" },
    { type: "Книги" },
    { type: "Туризм, рыбалка, охота" },
    { type: "Автотовары" },
    { type: "Мебель" },
    { type: "Хобби и творчество" },
    { type: "Ювелирные украшения" },
    { type: "Аксессуары" },
    { type: "Игры и консоли" },
    { type: "Канцелярские товары" },
    { type: "Антиквариат и коллекционирование" },
    { type: "Цифровые товары" },
    { type: "Бытовая химия и гигиена" },
    { type: "Музыка и видео" },
    { type: "Автомобили" },
  ];

  chainsPerDayNormal = 200 / 30;

  chainPrice = 24;
  chainsMin = 4;
  chainsMax = 250;

  chainsDefault = 10;

  reviewPrice = REVIEW_PRICE;

  chainsStep = 1;
  viewsStep = 10;

  keywords = OZON_KEYWORDS;

  targetLinkComment = "Укажите тут адрес вашего товара на OZON";
  targetLinkCommentShort = "Укажите ссылку товара";

  modes = [
    {
      id: MARKET_MODES.CHAINS,
      path: "/povedencheskie-faktory-na-ozon",
      rating: 0.968,
      title: "ПФ",
      navigateTitle: "Поведение и тест карточек товаров",
      icon: "lightning",
      iconForHomePage: "home-action",
      status: MARKET_MODE_STATUS.NEW,
      meta: {
        title: "Накрутка ПФ ЛЮДИ на OZON — просмотры, лайки | Boostclick",
        description: "Накрутка ПФ ЛЮДИ на OZON — просмотры, добавления.",
      },
      intro: {
        title: "Продвижение карточек на OZON* через ПФ",
        comment: "Только реальные пользователи и естественное взаимодействие:",
        points: [
          'Действия от пользователей с историей покупок на Ozon*',
          'Возможность выявить слабые места и улучшить позиционирование карточки',
          'Отложенная оплата — только после подтверждения отчета',
          'Потенциальное влияние на поведенческие сигналы: интерес к товару, глубина просмотра, переходы по ключам',
          'Без ботов и автоматизации — только живое участие',
        ],
      },
      howItWorks: [
        /* "Настройте параметры активности в соответствии с конкуренцией",
        "Укажите ссылку на товар для скриншота",
        "Укажите категорию, город и ключевые фразы из карточки товара",
        "После оплаты мы передадим исполнителю скриншот и параметры для поиска",
        "Проверьте ответы и активность, примите работу или отправьте на доработку", */
      ],
      stepPhrase1: "Настройте параметры взаимодействия пользователей с карточками на Ozon*",
      stepPhrase2: STEP_PHRASE_2,
      stepTwoTitleFaq: STEP_TWO_TITLE_FAQ,
      calculatorTitle: "Продвижение на Ozon* через взаимодействие пользователей",
      titleFAQ: "Вопрос-ответ про накрутку просмотров на Озон",
      faq: OZON_FAQ,
      // article: OZON_ARTICLE,
      actions: (() => {
        return [
          ...ACTIONS.filter(
            (action) =>
              action.type !== "MAIN.REVIEW" && !action.type.startsWith("VIEW.")
          ),
          ...ACTIONS.filter((action) => action.type === "MAIN.REVIEW"),
        ];
      })(),
      notice: [
        'Сервис создает задания для тестировщиков с индивидуальными сценариями взаимодействия.',
        'Цепочки действий формируются на основе заданных вами параметров: поисковых запросов, категории, интересующих действий.',
        'Каждому исполнителю выдается уникальное задание, которое предполагает:',
        '– Поиск товара по ключевой фразе',
        '– Переход на карточку и изучение контента',
        '– Добавление в избранное или корзину (по вашему выбору)',
        '– Взаимодействие с похожими товарами или фильтрами (если указано)',
        'Сценарии помогают собрать обратную связь и проанализировать, как пользователь воспринимает карточку товара в естественных условиях.',
        'Сложность заданий и сроки выполнения зависят от количества сценариев и действий в проекте.',
      ],
    },
  ];

  actionsMap = ACTIONS.reduce((map, action) => {
    map[action.type] = action;
    return map;
  }, {});

  emptyUrlStr = 'Укажите ссылку на товар';
  invalidUrlStr = 'Укажите корректную ссылку на товар';
}

const Ozon = new OzonClass();
export default Ozon;
